import { gql, useMutation } from "@apollo/client";
import { Clinic } from "../../types";

interface UpdateProtocolVisibilityVariables {
  protocolId: string;
  clinicIds: string[];
}

interface UpdateProtocolVisibilityResponse {
  updateProtocolVisibility: {
    id: string;
    visibleToClinics: Clinic[];
  };
}

const mutation = gql`
  mutation updateProtocolVisibility($protocolId: ID!, $clinicIds: [ID!]!) {
    updateProtocolVisibility(protocolId: $protocolId, clinicIds: $clinicIds) {
      id
      visibleToClinics {
        id
        name
      }
    }
  }
`;

export function useUpdateProtocolVisibility() {
  return useMutation<UpdateProtocolVisibilityResponse, UpdateProtocolVisibilityVariables>(
    mutation,
    {
      refetchQueries: ["protocols", "allProtocols", "protocol"],
    },
  );
}
